import { FC, PropsWithChildren } from 'react'
import clx from '../util/clx'
import ModalHeader from './ModalHeader'

type ModalProps = {
	title: string
	name: string
	onClose: () => void
	active: boolean
	popup?: boolean
}

export type ModalComponentProps = Omit<ModalProps, 'title' | 'name'>

const Modal: FC<PropsWithChildren<ModalProps>> = props => {
	const { popup, title, name, active, onClose, children } = props

	const className = clx('modal', `modal--${name}`, {
		'modal--active': active,
		'modal--popup': popup,
	})

	return (
		<div className={className}>
			<ModalHeader onClose={onClose}>{title}</ModalHeader>
			<div className="modal__content">{children}</div>
		</div>
	)
}

export default Modal
